import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import LocationAdd from './Add';
import LocationList from './LocationList';
import SkeletonContainer from '../Layout/SkeletonContainer';
import Search from '../Layout/Search';

class Locations extends Component {

    render(){
        const { getLocations, locationsMeta } = this.props;
        return (
                <SkeletonContainer title="LOCATIONS">
                    <Search endpoint="locations" width="40%" addModal={props => <LocationAdd {...props}/>}  meta={locationsMeta} getData={getLocations}/>
                    <LocationList />
                </SkeletonContainer>   
        );
    }
}

const mapStateToProps = (state) => ({
    locationsMeta: state.locationStore.locationsMeta,
});

export default connect(mapStateToProps,Actions.locations)(Locations);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/index.js